import { render, staticRenderFns } from "./RegisterIntern.vue?vue&type=template&id=89efb112"
import script from "./RegisterIntern.vue?vue&type=script&lang=js"
export * from "./RegisterIntern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports